import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderFilePickerComponent } from './dynamic-page-builder-file-picker.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderFilePickerFormComponent } from './file-picker-form/page-builder-file-picker-form.component';

@NgModule({
    declarations: [
        PageBuilderFilePickerFormComponent, DynamicPageBuilderFilePickerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderFilePickerComponent
    ]
})
export class PageBuilderFilePickerModule {}